// Экран «приложение открыто вне Telegram» — spec/08_copy.md этой ситуации не знает:
// она инженерная, а не продуктовая. Тон — «своя в чате», без канцелярита и без объяснений
// про initData: человеку незачем знать, почему именно не работает, ему нужно, куда идти.
import type { WebStubCopy } from './types'

export const webStub: WebStubCopy = {
  title: 'Ой, я тут не живу',
  body: 'Я живу в Telegram — там у меня звёзды, узы и все твои. Жми кнопку, открою.',
  cta: 'Открыть Луню в Telegram',
}
